import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './CustomTimeModal.css';
import DateBox from '../DateBox';
import MonthSelectBox from '../MonthSelectBox';
import ApplyBox from '../ApplyBox';

class CustomTimeModal extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.showModalCustomTime}
        onHide={this.props.handleClose}
        className={styles.dialog}
      >
        <Modal.Header className={styles.header}>
          <i
            className="fa fa-times-thin fa-2x"
            onClick={this.props.handleClose}
          />
          <Modal.Title className={styles.title}>Custom Time</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div>
              <ApplyBox
                onApply={this.props.clickApply}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                startHour={this.props.startHour}
                endHour={this.props.endHour}
                allDay={this.props.allDay}
                prevStartHour={this.props.prevStartHour}
                prevEndHour={this.props.prevEndHour}
                prevAllDay={this.props.prevAllDay}
                setAllDayCalendar={this.props.clickAllDay}
                showModalCustomTime={this.props.showModalCustomTime}
                closeCustomTime={this.props.handleClose}
              />
            </div>
          </div>
          <hr className={styles.separator} />
          <div className={`row ${styles['date-box']}`}>
            <MonthSelectBox
              month={this.props.month}
              year={this.props.year}
              onChange={this.props.changeMonthSelectBox}
            />
            <DateBox
              startDate={this.props.startDate}
              endDate={this.props.endDate}
              month={this.props.month}
              year={this.props.year}
              onChange={this.props.changeDateBox}
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default CustomTimeModal;
